import * as React from 'react';
import './App.css';
import { Provider } from 'mobx-react';
import { createMuiTheme, MuiThemeProvider, CssBaseline, Grid } from '@material-ui/core';

import KlientStore from './stores/KlientStore';
import Klient from './models/Klient';
import ObjednavkaStore from './stores/ObjednavkaStore';
import TurnusStore from './stores/TurnusStore';
import DenStore from './stores/DenStore';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Clients from './components/Clients';
import RESTApiService from './services/RESTApiService';
import ClientDetail from './components/ClientDetail';
import Orders from './components/Orders';
import MealsToMakeReport from './components/MealsToMakeReport';
import LoginForm from './components/LoginForm';
import ReportStore from './stores/ReportStore';
import CiselnikyStore from './stores/CiselnikyStore';
import {observer} from 'mobx-react';
import { observable, computed } from 'mobx';
import AuthStore from './stores/AuthStore';
import OrderNew from './components/OrderNew';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import OrderDetail from './components/OrderDetail';
import PaymentDetailsReview from './components/PaymentDetailsReview';
import HistorieStore from 'src/stores/HistorieStore';
import FakturaceStore from 'src/stores/FakturaceStore';
import OrderFakturace from 'src/components/OrderFakturace';
import DeliveryPlan from 'src/components/DeliveryPlan';
import RozvozStore from 'src/stores/RozvozStore';
import WebOrders from './components/WebOrders';
import WebOrderDetail from './components/WebOrderDetail';
import { Config } from './Config';
import OrderNewPreview from "./components/OrderNewPreview";
import LoggingBase from "./logging/LoggingBase";
import ConsoleLogger from "./logging/ConsoleLogger";
import LocalLogStore from "./logging/LocalLogStore";
import LocalStoreLogger from "./logging/LocalStoreLogger";
import SmartEmailingReport from "./components/SmartEmailingReport";

const theme = createMuiTheme(Config.theme);

@observer
class App extends React.Component {
  private authStore: AuthStore = new AuthStore();
  private klientStore: KlientStore = new KlientStore(new RESTApiService(this.authStore));
  private objednavkaStore: ObjednavkaStore = new ObjednavkaStore(new RESTApiService(this.authStore));
  private turnusStore: TurnusStore = new TurnusStore(new RESTApiService(this.authStore));
  private denStore: DenStore = new DenStore(new RESTApiService(this.authStore));
  private reportStore: ReportStore = new ReportStore(new RESTApiService(this.authStore));
  private ciselnikStore: CiselnikyStore = new CiselnikyStore(new RESTApiService(this.authStore));
  private historieStore: HistorieStore = new HistorieStore(new RESTApiService(this.authStore));
  private fakturaceStore: FakturaceStore = new FakturaceStore(new RESTApiService(this.authStore));
  private rozvozStore: RozvozStore = new RozvozStore(new RESTApiService(this.authStore));

  private loggingStore: LocalLogStore = new LocalLogStore(150);
  private loggingBase: LoggingBase = new LoggingBase(new ConsoleLogger(console.log), new LocalStoreLogger(this.loggingStore));

  @observable private klientsLoaded: boolean = false;
  @observable private turnusyLoaded: boolean = false;
  @observable private objednavkyLoaded: boolean = false;
  @observable private ciselnikLoaded: boolean = false;
  @observable private fakturaceSubjectsLoaded: boolean = false;
  @observable private fakturaceAvailableSubjectsLoaded: boolean = false;
  @observable private emailsCountLoaded: boolean = false;

  @computed private get allLoaded(): boolean {
    if(this.klientsLoaded 
        && this.turnusyLoaded 
        && this.objednavkyLoaded 
        && this.ciselnikLoaded
        && this.fakturaceSubjectsLoaded
        && this.fakturaceAvailableSubjectsLoaded
        && this.emailsCountLoaded) {
      return true;
    }
    return false;
  }

  @computed private get loadStarted(): boolean {
    if(this.authStore.isAuthenticated) {
      const api = new RESTApiService(this.authStore);
      api.getKlients().then(a => {
        a.forEach(item => this.klientStore.klients.push(new Klient().loadFromJSON(item)));
        this.klientsLoaded = true;
      });
      this.objednavkaStore.loadAll().then(success => {
        this.objednavkyLoaded = true;
      });
      this.turnusStore.loadAll().then(success => {
        this.turnusyLoaded = true;
      });
      this.ciselnikStore.loadAll().then(success => {
        this.ciselnikLoaded = true;
      });
      this.fakturaceStore.loadFakturacniSubjektyAll().then(sucess => {
        this.fakturaceSubjectsLoaded = true;
      });
      this.fakturaceStore.loadAvailableSubjects().then(sucess => {
        this.fakturaceAvailableSubjectsLoaded = true;
      });
      this.reportStore.loadEmailsCount().then(success => {
        this.emailsCountLoaded = true;
      })
      return true;
    }
    return false;
  }

  constructor(props: Readonly<any>) {
    super(props);
  }

  public render() {
    return (
      <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <Provider authStore={this.authStore} 
                    klientStore={this.klientStore} 
                    objednavkaStore={this.objednavkaStore} 
                    turnusStore={this.turnusStore} 
                    denStore={this.denStore} 
                    reportStore={this.reportStore} 
                    ciselnikyStore={this.ciselnikStore} 
                    historieStore={this.historieStore}
                    fakturaceStore={this.fakturaceStore}
                    rozvozStore={this.rozvozStore}
                    loggingBase={this.loggingBase}
                    loggingStore={this.loggingStore}>
        {this.authStore.isAuthenticated ? (        
        (this.loadStarted && this.allLoaded) ?
          <MuiPickersUtilsProvider utils={MomentUtils} locale='cs'>
            <Router>
              <div>
                <Route path="/clients" component={this.Clients} exact />
                <Route path="/clients/:id" component={this.ClientDetail} />
                <Route path="/" component={this.Clients} exact />
                <Route path="/orders" component={this.Orders} exact />
                <Route path="/orders/:id" component={this.OrderDetail} exact/>
                <Route path="/orders/:id/invoicing" component={this.OrderFakturace} exact/>
                <Route path="/orders/:id/invoicingFromNew" component={this.OrderFakturaceFromNew} exact/>
                <Route path="/neworder/:id" component={this.NewOrder} exact />
                <Route path="/neworder" component={this.NewOrderTemplate} exact />
                <Route path="/neworderPreview" component={this.NewOrderPreview} exact />
                <Route path="/report/mealsToMake" component={this.MealsToMakeReport} exact />
                <Route path="/report/deliveryPlan" component={this.DeliveryPlan} exact />
                <Route path="/paymentDetails/:id" component={this.PaymentDetailsReview} />
                <Route path="/web-orders" component={this.WebOrders} exact />
                <Route path="/web-orders/:id" component={this.WebOrderDetail} exact/>
                <Route path="/report/smartEmailing" component={this.SmartEmailing} exact/>
              </div>
            </Router>
          </MuiPickersUtilsProvider>
        : <div>Načítám data, prosím čekejte</div>
        ) : <div><LoginForm /></div>}
        </Provider>
      </MuiThemeProvider>
    );
  }

  private Clients = () => (<Clients />)
  private Orders = () => (<Orders />)
  private WebOrders = () => (<WebOrders />)
  private NewOrder = (match) => (<OrderNew klientId={+match.match.params.id} />)
  private NewOrderTemplate = () => (<OrderNew orderTemplate={this.objednavkaStore.orderTemplate} />)
  private OrderDetail = (match) => (<OrderDetail objednavkaId={+match.match.params.id} />)
  private WebOrderDetail = (match) => (<WebOrderDetail objednavkaId={+match.match.params.id} />)
  private ClientDetail = (match) => (<ClientDetail klientId={+match.match.params.id} />)
  private MealsToMakeReport = () => (<MealsToMakeReport />)
  private PaymentDetailsReview = (match) => (<PaymentDetailsReview objednavkaId={+match.match.params.id} />)
  private OrderFakturace = (match) => (<OrderFakturace objednavkaId={+match.match.params.id} fromNewOrder={false} />)
  private OrderFakturaceFromNew = (match) => (<OrderFakturace objednavkaId={+match.match.params.id} fromNewOrder={true} />)
  private DeliveryPlan = () => (<DeliveryPlan />)
  private NewOrderPreview = () => (<OrderNewPreview orderTemplate={this.objednavkaStore.orderTemplate} />)
  private SmartEmailing = () => (<SmartEmailingReport />)
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx